export default __webpack_public_path__ + "static/media/fileUpload.60f64d6f.svg";